// pages/AdminPortal/AdminDashboard.jsx
import React from 'react';
import { Typography, Card, CardContent, Grid } from '@mui/material';

const AdminDashboard = () => {
  const stats = [
    { title: 'Total Users', value: 150 },
    { title: 'Active Sessions', value: 50 },
    { title: 'Revenue', value: '$10,000' },
  ];

  return (
    <div>
      <Typography variant="h4">Dashboard</Typography>
      <Grid container spacing={3}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardContent>
                <Typography variant="h6">{stat.title}</Typography>
                <Typography variant="h4">{stat.value}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default AdminDashboard;